module.exports = __webpack_public_path__ + "img/use_five.0912d1e1.jpg";